var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInviteSmall = function SvgInviteSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 74 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.667,
    cy: 36.667,
    r: 36.667,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    fillRule: "nonzero",
    d: "M36.667 40c11.085 0 20.378 8.1 21.66 18.748a.83.83 0 0 1-.322.762c-6.048 4.61-13.495 7.157-21.338 7.157s-15.29-2.546-21.338-7.155a.83.83 0 0 1-.322-.763C16.287 48.102 25.58 40 36.667 40m19.896 18.17c-1.529-9.42-9.921-16.503-19.896-16.503-10.083 0-18.548 7.238-19.943 16.808C22.414 62.682 29.357 65 36.667 65c7.143 0 13.937-2.214 19.553-6.242l.39-.284z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.667,
    cy: 67.5,
    r: 11.667,
    fill: "#F3F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    fillRule: "nonzero",
    d: "M41.174 55.838A12.5 12.5 0 0 0 36.667 55c-6.904 0-12.5 5.596-12.5 12.5S29.763 80 36.667 80c6.903 0 12.5-5.596 12.5-12.5 0-1.452-.129-2.543-.608-3.883a.758.758 0 0 0-1.426.51c.42 1.177.519 2.096.519 3.373 0 6.067-4.919 10.985-10.985 10.985-6.067 0-10.985-4.918-10.985-10.985S30.6 56.515 36.667 56.515c1.372 0 2.709.252 3.96.736a.758.758 0 1 0 .547-1.413"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    fillRule: "nonzero",
    d: "M48.09 56.24a.833.833 0 0 1 0 1.179l-9.747 9.745 3.913 3.913a.834.834 0 0 1 .075 1.094l-.075.085a.833.833 0 0 1-1.179 0l-3.912-3.914-3.913 3.914a.833.833 0 0 1-1.178-1.179l3.913-3.913-4.076-4.075a.834.834 0 0 1-.075-1.093l.075-.085a.833.833 0 0 1 1.178 0l4.076 4.075 9.746-9.746a.833.833 0 0 1 1.178 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7780",
    fillRule: "nonzero",
    d: "M36.667 16.667c6.903 0 12.5 5.596 12.5 12.5 0 6.903-5.597 12.5-12.5 12.5-6.904 0-12.5-5.597-12.5-12.5 0-6.904 5.596-12.5 12.5-12.5m0 1.666c-5.983 0-10.834 4.85-10.834 10.834C25.833 35.15 30.683 40 36.667 40 42.65 40 47.5 35.15 47.5 29.167s-4.85-10.834-10.833-10.834"
  }))));
};
export default SvgInviteSmall;